import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash/fp'
import { useHistory } from 'react-router'
import useAsync from '../hooks/useAsync'
import { useClaimant } from '../context/col'
import { useStyles } from './styled'
import theme, { specialTheme } from '../theme'
import OrdinaryButton from '../components/OrdinaryButton'
import getCountries from '../services/lookup/getCountries'
import getDestinations from '../services/lookup/getDestinations'
import getCurrencies from '../services/lookup/getCurrencies'
import getWebUser, { getWebUserParams } from '../services/auth/getWebUser'
import { pathToLeadingPage, pathToRootPage } from '../containers/App/RouterApp'
import { useParams } from 'react-router-dom'
import { isDEV } from '../helpers'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useVocabulary } from '../context/vocabulary'
import { ColplAppLayout } from '../components/layout/ColplAppLayout'
import { UserProfileDataType } from '../models'
import { AxiosResponse } from 'axios'

const FrontInitPage = () => {
  //@ts-ignore
  const { type, webuserid } = useParams()
  //const search = useLocation().search
  //const param_locale = new URLSearchParams(search).get('__locale')
  const { t } = useTranslation()
  const { state, dispatch } = useClaimant()
  const { vocabulary, dispatchVocabulary } = useVocabulary()
  const history = useHistory()
  const lang = t('appl.header.language') === 'EN' ? 'en' : 'pl'

  useEffect(() => {
    // Reset original shared 'col' context.
    dispatch({
      type: 'initial_state',
    })

    // Reset the token in the storage
    localStorage.removeItem('token')

    // Set caseType to caseType given in params
    if (!state.caseType && !!type) {
      dispatch({
        type: 'case_type',
        payload: { caseType: type },
      })
    }
  }, [])

  /* Start loading dynamic shit ... */
  useEffect(() => {
    if (Boolean(webuserid)) {
      dispatch({
        type: 'WebUserId_received',
        payload: { webUserId: webuserid },
      })
      fetchWebUser({ webuserid: webuserid })
    }
    if (isEmpty(vocabulary.currencies)) fetchCurrencies()
    if (isEmpty(vocabulary.countries)) fetchCountries()
    if (isEmpty(vocabulary.destinations)) fetchDestinations()
  }, [])

  /**
   * When dynamic shit is loaded, and no error is here,
   * leave the init page and:
   * a) go to the first page
   * TODO b) go to the original page if this is a re-init of previous app after F5 or opening app from link...
   */
  useEffect(() => {
    const caseType = state.caseType
    const error = state.error
    if (caseType == null) {
      // we cannot go to next page -- we don't know our CaseType !!!
      return
    }
    if (error) {
      // There is error somewhere --> we cannot go to the first page
      return
    }
    const allDynamicLookupsLoaded: boolean =
      !isEmpty(vocabulary.currencies) &&
      !isEmpty(vocabulary.countries) &&
      !isEmpty(vocabulary.destinations)

    if (allDynamicLookupsLoaded) {
      // go to first page if all shit is dynamically loaded and there is no issue
      history.push(`/${caseType}/insurance`)
    }
  }, [
    vocabulary.currencies,
    vocabulary.countries,
    vocabulary.destinations,
    state.error,
    state.caseType,
  ])

  //
  // Pomocne funkce nacitani dynamickeho shit...
  //
  const getLookupCountries = () => {
    return async () => {
      try {
        const res: any = await getCountries(lang)
        dispatchVocabulary({
          type: 'load_countries',
          payload: { countries: res?.data },
        })
      } catch (error) {
        dispatch({ type: 'error', payload: { error: error.message } })
        throw error
      }
    }
  }
  const { fetch: fetchWebUser } = useAsync({
    promiseFn: (values: getWebUserParams) => getWebUserData(values),
  })

  const getWebUserData = (values: getWebUserParams) => {
    return async () => {
      try {
        const res: AxiosResponse<UserProfileDataType> = await getWebUser(values)
        if (res?.data) {
          dispatch({
            type: 'WebUserLoaded',
            payload: {
              webUserId: values.webuserid,
              webUser: res?.data,
            },
          })
        }
      } catch (error) {
        const errorConvertToString = error.toString()
        if (!errorConvertToString.includes('422')) {
          dispatch({ type: 'error', payload: { error: error.message } })
          throw error
        }
      }
    }
  }

  const { fetch: fetchCurrencies } = useAsync({
    promiseFn: () => getLookupCurrencies(),
  })

  const getLookupCurrencies = () => {
    return async () => {
      try {
        const res: any = await getCurrencies(lang)
        dispatchVocabulary({
          type: 'load_currencies',
          payload: { currencies: res?.data },
        })
      } catch (error) {
        dispatch({ type: 'error', payload: { error: error.message } })
        throw error
      }
    }
  }

  const { fetch: fetchCountries } = useAsync({
    promiseFn: () => getLookupCountries(),
  })

  const getLookupDestinations = () => {
    return async () => {
      try {
        const res: any = await getDestinations(lang)
        dispatchVocabulary({
          type: 'load_destinations',
          payload: { destinations: res?.data },
        })
      } catch (error) {
        dispatch({ type: 'error', payload: { error: error.message } })
        throw error
      }
    }
  }

  const { fetch: fetchDestinations } = useAsync({
    promiseFn: () => getLookupDestinations(),
  })

  return (
    <ColplAppLayout
      body={
        Boolean(state.error) ? (
          <InitErrorBox
            errorMessage={
              process.env.NODE_ENV === 'development' ? state.error : t('error')
            }
          />
        ) : (
          <InitLoadingBox />
        )
      }
    />
  )
}

const InitErrorBox = (props: { errorMessage: string }) => {
  const classes = useStyles(theme)
  const history = useHistory()
  const { t } = useTranslation()

  return (
    <Grid className={classes.root}>
      <Grid
        sm={12}
        xl={12}
        xs={12}
        container
        direction="row"
        className={classes.gridMainForm}
      >
        <Grid item xs={12} sm={12} xl={12} className={classes.gridButton}>
          <Alert severity="error" className={classes.error}>
            {props.errorMessage}
          </Alert>
        </Grid>
        <Grid item xs={12} sm={12} xl={12} className={classes.gridButton}>
          <OrdinaryButton onClick={() => window.location.reload()}>
            {t('refresh')}
          </OrdinaryButton>
          <Grid item xs={1} sm={1} xl={1} />
          <OrdinaryButton
            onClick={() => {
              isDEV
                ? history.push(pathToRootPage)
                : (window.location.href = pathToLeadingPage)
            }}
          >
            {t('backBtn')}
          </OrdinaryButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

const InitLoadingBox = () => {
  const classes = useStyles(theme)
  return (
    <Grid className={classes.root}>
      <Grid
        sm={12}
        xl={12}
        xs={12}
        item
        container
        direction="row"
        className={classes.gridMainForm}
      >
        <Grid
          sm={12}
          xl={12}
          xs={12}
          item
          className={classes.loadCircle}
          spacing={2}
          container
        >
          <div color={specialTheme.colors.darkRed}>
            <CircularProgress
              // @ts-ignore
              color="inherit"
              size="2rem"
            />
          </div>
        </Grid>
      </Grid>
    </Grid>
  )
}
export default FrontInitPage
